module.exports = __webpack_public_path__ + "img/View.96148b06.svg";